import React from "react"

const OpeningQuotationMark = ({ language }) => {
  switch (language) {
    case "de":
    case "pl":
      return (
        <span className={`w-full max-w-full fill-cyan`}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26.63 24.07">
            <path d="M0 0h10.65v11.47c.23 6.6-4.42 11.77-10.65 12.6v-4.95c3.82-1.27 4.95-3.9 4.95-7.58H0V0zm15.97 0h10.65v11.47c.23 6.6-4.42 11.77-10.65 12.6v-4.95c3.82-1.27 4.95-3.9 4.95-7.58h-4.95V0z" />
          </svg>
        </span>
      )
    case "es":
    case "fr":
    case "pt":
      return (
        <span className={`w-full max-w-full fill-cyan`}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27 28.72">
            <path d="M0 19.35V9.23L11.77 0v9l-6.75 5.33 6.75 5.4v9L0 19.35zm15.22 0V9.23L27 0v9l-6.75 5.33 6.75 5.4v9l-11.77-9.38z" />
          </svg>
        </span>
      )
    case "jp":
      return (
        <span className={`w-full max-w-full fill-cyan`}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24.16 50.74">
            <path d="M24.16 7.27H7.33v43.47H0V0h24.16v7.27z" />
          </svg>
        </span>
      )
    default:
      return (
        <span className={`w-full max-w-full fill-cyan`}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26.63 24.07">
            <path d="M10.66 24.07H0V12.59C-.22 6 4.43.83 10.66 0v4.95c-3.82 1.27-4.95 3.9-4.95 7.57h4.95v11.55zm15.97 0H15.98V12.59C15.75 5.99 20.4.82 26.63-.01v4.95c-3.82 1.27-4.95 3.9-4.95 7.57h4.95v11.55z" />
          </svg>
        </span>
      )
  }
}

const ClosingQuotationMark = ({ language }) => {
  switch (language) {
    case "de":
      return (
        <span className={`w-full max-w-full fill-cyan`}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26.63 24.07">
            <path d="M10.66 24.07H0V12.6C-.22 6 4.43.82 10.66 0v4.95c-3.82 1.28-4.95 3.9-4.95 7.57h4.95v11.55zm15.97 0H15.98V12.6C15.75 6 20.4.82 26.63 0v4.95c-3.83 1.28-4.95 3.9-4.95 7.57h4.95v11.55z" />
          </svg>
        </span>
      )
    case "es":
    case "fr":
    case "pt":
      return (
        <span className={`w-full max-w-full fill-cyan`}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27 28.72">
            <path d="M11.78 9.22v10.12L0 28.72v-9l6.75-5.4L0 9V0l11.78 9.22zm15.22 0v10.12l-11.77 9.38v-9l6.75-5.4-6.75-5.33V0L27 9.22z" />
          </svg>
        </span>
      )
    case "jp":
      return (
        <span className={`w-full max-w-full fill-cyan`}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24.1 50.68">
            <path d="M24.1 50.68H0v-7.27h16.77V0h7.33v50.68z" />
          </svg>
        </span>
      )
    case "pl":
    default:
      return (
        <span className={`w-full max-w-full fill-cyan`}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26.63 24.07">
            <path d="M0 0h10.65v11.47c.23 6.6-4.42 11.77-10.65 12.6v-4.95c3.83-1.27 4.95-3.9 4.95-7.57H0V0zm15.97 0h10.65v11.47c.22 6.6-4.42 11.77-10.65 12.6v-4.95c3.82-1.27 4.95-3.9 4.95-7.57h-4.95V0z" />
          </svg>
        </span>
      )
  }
}

export { OpeningQuotationMark, ClosingQuotationMark }
